import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import { ChevronLeft, ChevronRight, X } from "lucide-react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

interface OrderImage {
    id: number;
    url: string;
    file_name: string;
    category: string;
}

interface ImageLightboxProps {
    images: any[];
    initialIndex: number;
    onClose: () => void;
}

const ImageLightbox: React.FC<ImageLightboxProps> = ({ images, initialIndex, onClose }) => {
    return (
        <div className="fixed inset-0 z-[9999] bg-black bg-opacity-95 flex items-center justify-center">
            {/* دکمه بستن */}
            <button
                onClick={onClose}
                className="absolute top-4 right-4 text-white text-3xl hover:text-gray-300 z-50"
            >
                <X size={32} />
            </button>

            <Swiper
                modules={[Navigation, Pagination]}
                navigation={{
                    prevEl: ".custom-prev",
                    nextEl: ".custom-next",
                }}
                pagination={{ clickable: true, dynamicBullets: true }}
                initialSlide={initialIndex}
                spaceBetween={30}
                slidesPerView={1}
                className="w-full h-full"
                style={{ zIndex: 40 }}
            >
                {images.map((img) => (
                    <SwiperSlide key={img.id} className="flex items-center justify-center p-4">
                        <img
                            src={img.url}
                            alt={img.file_name}
                            className="max-h-full max-w-full object-contain select-none"
                            draggable={false}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>

            {/* دکمه‌های نویگیشن */}
            <div className="custom-prev absolute left-4 top-1/2 -translate-y-1/2 text-white text-4xl cursor-pointer hover:text-gray-300 z-50">
                <ChevronLeft size={48} />
            </div>
            <div className="custom-next absolute right-4 top-1/2 -translate-y-1/2 text-white text-4xl cursor-pointer hover:text-gray-300 z-50">
                <ChevronRight size={48} />
            </div>
        </div>
    );
};

export default ImageLightbox;